import { render, staticRenderFns } from "./OnboardingChooseDomainModal.vue?vue&type=template&id=56ce362c&scoped=true"
import script from "./OnboardingChooseDomainModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseDomainModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseDomainModal.vue?vue&type=style&index=0&id=56ce362c&prod&lang=scss&scoped=true"
import style1 from "./OnboardingChooseDomainModal.vue?vue&type=style&index=1&id=56ce362c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce362c",
  null
  
)

export default component.exports